export default __webpack_public_path__ + "static/media/trailers.37b221f9.jpg";